import React from 'react';
import bindAll from 'lodash.bindall';
import classNames from 'classnames';
import { connect } from 'react-redux';

//引入monaco编辑器
import 'monaco-editor/esm/vs/editor/editor.all.js'
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import MonacoEditor from 'react-monaco-editor';


import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { Select, Switch } from 'antd';
const { Option } = Select;

import scratchBlocks from 'scratch-blocks';
import play from '../gui/icon--play.svg';
import stop from '../gui/icon--stop.svg';
import download from '../gui/icon--download.svg';
import empty from '../gui/icon--empty.svg';

import setting from './setting.svg'

import analytics from '../../lib/analytics';
import pythonToken from './pythonToken.js';
import fnHints from './funtionHints.js';

import styles from './code-mirror.css';
import { setPythonModifly } from '../../reducers/menus';

if (window.require != undefined) {
    var ipcRenderer = window.require('electron').ipcRenderer;
}


const messages = defineMessages({
    stopTitle: {
        id: 'gui.controls.stop',
        defaultMessage: 'Stop',
        description: 'Stop button title'
    },
    downTitle: {
        id: 'gui.controls.down',
        defaultMessage: 'Download',
        description: 'Download button title'
    },
    runTitle: {
        id: 'gui.controls.run',
        defaultMessage: 'Run',
        description: 'Run button title'
    },
    clearTitle: {
        id: 'gui.controls.clear',
        defaultMessage: 'Clear',
        description: 'Clear button title'
    },
    clearCode: {
        id: 'gui.menuBar.tip11Title',
        defaultMessage: "清除代码",
        description: "Text for tip11"
    },
    clearAllcode: {
        id: "gui.menuBar.tip11",
        defaultMessage: "确认清除所有代码？",
        description: "Text for tip11"
    }
});
class CodeMirrors extends React.Component {
    constructor(props) {
        super()
        this.state = {
            theme: 'dark',
            fontSize: '15',
            lineNumbers: true,
            showSetting: 0,
            value: '',
            show: true,
            fontSizeOptions: [
                '15',
                '16',
                '17',
                '18',
                '19',
                '20',
                '21'
            ],
            themeOption: [
                'dark',
                'vs'
            ],
            clickOnce: false
        }
        this.editor = null
        bindAll(this, [
            'handlechange',
            'handleStopAllClick',
            'pythonRun',
            'pythonDownload',
            'pythonClear',
            'handleChangeSelect',
            'handleShowSetting',
            'handleChangeSwitch',
            'editorWillMount',
            'handleFontSizeChange'
        ])
    }
    componentDidMount() {
        window.addEventListener('resize', () => {
            this.editor.layout();
        })
    }
    componentDidUpdate() {
        this.editor.layout();
    }
    shouldComponentUpdate(props, state) {
        if (this.props.monacodeValue != props.monacodeValue ||
            this.state.theme != state.theme ||
            this.state.fontSize != state.fontSize ||
            this.state.showSetting != state.showSetting ||
            this.state.show != state.show ||
            this.state.fontSizeOptions != state.fontSizeOptions ||
            this.state.themeOption != state.themeOption ||
            this.state.clickOnce != state.clickOnce ||
            this.state.lineNumbers != state.lineNumbers ||
            this.props.showtitle != props.showtitle) {
            return true
        }
        return false
    }
    componentWillMount() {
        monaco.languages.register({ id: 'bbb' });
        monaco.languages.setMonarchTokensProvider('bbb', pythonToken);
    }
    componentWillUnmount(){
        this.dispose && this.dispose()
    }
    handlechange(value, editor) {
        value = value.replace(/ /ig, " ")

        this.props.setPythonModifly(true)
        this.props.setMonaCodeValue(value)
    }
    //切换主题
    handleChangeSelect(themeValue) {
        this.setState({
            theme: themeValue
        })
    }
    //设置字体大小
    handleFontSizeChange(size) {
        this.setState({
            fontSize: size
        })
    }
    //显示设置
    handleShowSetting() {
        if (this.state.showSetting == 0 || this.state.showSetting == 2) {
            this.setState({
                showSetting: 1
            })
        } else {
            this.setState({
                showSetting: 2
            })
        }
    }
    //是否显示数字
    handleChangeSwitch(num) {
        this.setState({
            lineNumbers: num
        })
    }

    //停止按钮事件
    handleStopAllClick(e) {
        e.preventDefault();
        this.props.vm.stopAll(localStorage.getItem('default_robot') || 'E6');
        analytics.event({
            category: 'general',
            action: 'Stop Button'
        });
    }

    //运行python代码
    pythonRun() {
        //  /\r\n +/g  匹配后面有空格，把空格替换掉
        //  /\r\n\r\n/g   匹配到两个换行就替换为四个换行
        let content = this.editor.getValue().replace(/\r\n +/g, "\r\n\t").replace(/\r\n\r\n/g, "\r\n\r\n\r\n\r\n");
        let projectTitle = this.props.projectTitle;
        console.log(this.editor.getValue(), content)

        content += '\r\n# DEBUG_END';
        var json = {
            command: 'USB_DEBUG',
            content: content,
            mode: 0xFF
        }

        if (ipcRenderer) {
            if (window.__yourReactComp__.state.link == false) {
                let data = {
                    command: 'USB_CONNECTION',
                    rcu: localStorage.getItem('default_robot')
                }
                ipcRenderer.send('udp_cmd', data)
                localStorage.setItem('default_robot', data.rcu);
                ipcRenderer.once('link-reply', (event, arg) => {
                    // console.log('设备未连接，尝试连接，结果:', arg)
                    if (arg === 'USB_CONNECTION_OK') {
                        ipcRenderer.send('udp_py', content);
                    } else {
                        downloadAlert({ show: true, type: 'Error', content: window.__yourReactComp__.blocksData.Msg['gui.menuBar.tip5'], animation: true, duration: 2000 })
                    }
                })
            } else {
                ipcRenderer.send('udp_py', content);
            }
        } else {
            downloadAlert({
                show: true,
                type: 'Error',
                animation: true,
                content: scratchBlocks.Msg['gui.menuBar.tip5'],
                duration: 2000
            })
        }
    }
    //下载python文件
    pythonDownload() {

        if (window.__yourReactComp__.state.link == false) {
            downloadAlert({ show: true, type: 'Error', content: window.__yourReactComp__.blocksData.Msg['gui.menuBar.tip5'], animation: true, duration: 2000 });
            return
        }

        var python = this.editor.getValue();
        const spriteName = localStorage.getItem('default_robot');
        const projectTitle = this.props.projectTitle;

        if (this.props.vm.robotType == 'STORM_OS') {
            if (python == "") {
                downloadAlert({ show: true, type: 'Error', content: "内容不能为空", animation: true, duration: 2000 });
                return
            }
            downloadAlert({ show: true, type: 'Info', content: "正在下载...", animation: true });
            var pythonfile = {
                fileName: projectTitle + '.py',
                code: python
            }
            ipcRenderer && ipcRenderer.send('STORM_OS_DownloadPython', pythonfile)
            return
        }
        if (this.props.vm.robotType == 'E7') {
            ipcRenderer && ipcRenderer.send('tcp_Send_60', projectTitle + '-----1' + python + '=')
            return
        }

        var json = {
            command: 'USB_DOWNLOAD',
            name: projectTitle + '.py',
            content: python,
            rcu: spriteName, // 机器人类型E6 C1 M6
            mode: 0xFF // 0x02: USB连接，下载界面； 0x11：蓝牙连接，主界面； 0x12：蓝牙连接，调试下载界面； 0x13：蓝牙连接，下载固件界面
        };
        if (python != '') {
            // 当python_down为true时才进入监听函数的执行块
            // 作用：这里的udp监听函数on存在bug，监听函数不会随着执行结束而销毁，导致监听函数累计，造成数据混乱
            // 并且：激活ipcMain.on后，不仅会从头到尾执行ipcMain.on的函数块，还会直接执行之前激活过的udp监听函数udpCmd.on
            // 所以这里通过设定一个标志去判断达到只执行当前监听函数的作用，因为只有从ipcMain.on开始执行，标志python_down才会被赋值true，才能进入udp.on

            let python_down = true
            // 下载前发送查询蓝牙类型（蓝牙主界面、蓝牙调试下载界面、蓝牙下载固件界面）
            const data = new Buffer([0x86, 0xAB, 0x14, 0xE8, 0x80, 0x00, 0x00, 0x00, 0x00, 0x00,
                0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0xCF]);
            ipcRenderer && ipcRenderer.send('udp_trans', data);
            ipcRenderer && ipcRenderer.once('getmode-reply', (event, arg) => {
                json.mode = arg
                ipcRenderer && ipcRenderer.send('udp_py', json);
            })
        } else {
            downloadAlert({ show: true, type: 'Error', content: window.__yourReactComp__.blocksData.Msg['gui.menuBar.tip7'], animation: true, duration: 2000 })
            // alert("下载文件内容不能为空")
        }

    }
    //清除pytohn代码
    pythonClear() {
        const intl = this.props.intl
        scratchBlocks.customConfirm(intl.formatMessage(messages.clearCode), intl.formatMessage(messages.clearAllcode), () => {
            this.props.setMonaCodeValue('')
        })
    }
    editorWillMount(monacos) {
        if (!this.state.clickOnce) {

            monaco.editor.defineTheme('dark', {
                base: 'vs-dark',
                inherit: true,  //继承
                rules: [
                    { token: 'custom-fn', foreground: '00ff1A' },
                    { token: 'custom-info', foreground: '808080' },
                    { token: 'custom-error', foreground: 'ff0000', fontStyle: 'bold' },
                    { token: 'custom-notice', foreground: 'FFA500' },
                    { token: 'custom-date', foreground: '008800' },
                    { token: 'fnName', foreground: 'ffa826' }
                ]
            });
            // var createDependencyProposals = fnHints

            let { dispose } = monaco.languages.registerCompletionItemProvider('bbb', {
                provideCompletionItems: function (model, position) {
                    // find out if we are completing a property in the 'dependencies' object.
                    // var textUntilPosition = model.getValueInRange({ startLineNumber: 1, startColumn: 1, endLineNumber: position.lineNumber, endColumn: position.column });
                    // var match = textUntilPosition.match(/"dependencies"\s*:\s*\{\s*("[^"]*"\s*:\s*"[^"]*"\s*,\s*)*([^"]*)?$/);
                    // if (!match) {
                    //     return { suggestions: [] };
                    // }
                    var word = model.getWordUntilPosition(position);
                    var range = {
                        startLineNumber: position.lineNumber,
                        endLineNumber: position.lineNumber,
                        startColumn: word.startColumn,
                        endColumn: word.endColumn

                    };
                    return {
                        suggestions: fnHints(range)
                    };
                },
                triggerCharacters: ['.']
            });
            this.dispose = dispose
            setTimeout(() => {
                console.log('a')
                let then = this
                this.editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_S, () => {
                    if (ipcRenderer) {
                        let Obj = {
                            projectTitle: this.props.projectTitle,
                            pythonModifly: this.props.pythonModifly,
                            saveFilePath: this.props.savePythonPath,
                            content: this.props.monacodeValue
                        }
                        ipcRenderer && ipcRenderer.send('save_python_File', Obj);
                        return
                    }
                    const inputPyDom = document.createElement('a')
                    const url = window.URL.createObjectURL(new Blob([this.props.monacodeValue]))
                    const title = this.props.projectTitle
                    inputPyDom.download = title + '.py';
                    inputPyDom.href = url
                    inputPyDom.click()
                    window.URL.revokeObjectURL(url)
                    inputPyDom.remove()

                });
                // this.editor.editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_V, function () {
                //     alert('F9 pressed!');
                // });

            }, 10)
            this.setState({
                clickOnce: true
            })
        }
    }
    render() {
        const {
            intl,
            monacodeValue,
            showtitle
        } = this.props
        return (
            <div className={classNames({ [styles.hide]: showtitle })}>
                <div className={classNames(styles.codeMirrors)} ref={(e) => { this.monacoContainers = e }}>

                    {this.state.show ? <MonacoEditor
                        height="100%"
                        language="bbb"
                        value={monacodeValue}
                        options={{
                            selectOnLineNumbers: false,
                            roundedSelection: false,
                            readOnly: false,        //是否只读
                            cursorStyle: "line",    //光标样式
                            automaticLayout: false,
                            lineNumbers: this.state.lineNumbers ? 'on' : 'off',
                            minimap: {
                                enabled: false  //是否显示左侧地图
                            },
                            contextmenu: false,
                            fontSize: this.state.fontSize,
                            fontWeight: '500'
                        }}
                        onChange={this.handlechange}
                        theme={this.state.theme}
                        editorWillMount={this.editorWillMount}
                        editorDidMount={editor => { this.editor = editor }}
                    /> : null}
                    <div
                        className={styles.btnBox}
                    >
                        <div
                            className={styles.runBtn}
                            onClick={this.handleStopAllClick}
                        >
                            <img
                                src={stop}
                                title={intl.formatMessage(messages.stopTitle)}
                            />
                        </div>
                        <div
                            className={styles.runBtn}
                            onClick={this.pythonRun}
                        >
                            <img
                                src={play}
                                title={intl.formatMessage(messages.runTitle)}
                            />
                        </div>
                        <div
                            className={styles.runBtn}
                            onClick={this.pythonDownload}
                        >
                            <img
                                src={download}
                                title={intl.formatMessage(messages.downTitle)}
                            />
                        </div>
                        <div
                            className={styles.clearBtn}
                            onClick={this.pythonClear}
                        >
                            <img
                                src={empty}
                                title={intl.formatMessage(messages.clearTitle)}
                            />
                        </div>
                    </div>
                    <div className={classNames(styles.settingBox, { [styles.showSetting]: this.state.showSetting == 1 }, { [styles.hideSetting]: this.state.showSetting == 2 })}>
                        <div className={styles.settingItem}>
                            <div>
                                <span className={styles.settingTitle}>主题</span>
                            </div>
                            <Select defaultValue={this.state.theme} style={{ width: '100%' }} onChange={this.handleChangeSelect}>
                                {this.state.themeOption.map((item, index) => {
                                    return <Option key={index} value={item}>{item}</Option>
                                })}
                            </Select>
                        </div>
                        <div className={styles.settingItem}>
                            <div>
                                <span className={styles.settingTitle}>字体大小</span>
                            </div>
                            <Select defaultValue={this.state.fontSize} style={{ width: '100%' }} onChange={this.handleFontSizeChange}>
                                {this.state.fontSizeOptions.map((item, index) => {
                                    return <Option key={index} value={item}>{item}</Option>
                                })}
                            </Select>
                        </div>
                        <div className={styles.settingItem}>
                            <div>
                                <span className={styles.settingTitle}>是否显示数字</span>
                            </div>
                            <Switch defaultChecked={this.state.lineNumbers} onClick={this.handleChangeSwitch} />
                        </div>
                        <div className={styles.settingBtn} onClick={this.handleShowSetting}>
                            <img
                                src={setting}
                                draggable={false}
                                title='设置'
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    projectTitle: state.scratchGui.projectTitle.title,
    pythonModifly: state.scratchGui.menus.python_modifly,
    savePythonPath: state.scratchGui.menus.save_python_path
});

const mapDispatchToProps = (dispatch) => ({
    setPythonModifly: (status) => {
        dispatch(setPythonModifly(status))
    }
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CodeMirrors)